'use strict';

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

var _localize = require('linksoft/core/localize');

var _localize2 = _interopRequireDefault(_localize);

var _notify = require('linksoft/notify');

var _notify2 = _interopRequireDefault(_notify);

var _message = require('linksoft/message');

var _message2 = _interopRequireDefault(_message);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Resx = (0, _localize2.default)('Messages', 'App');
var wishlistService = abp.services.api.wishlist;

(0, _jquery2.default)(document).on('click', '[data-watchdog]', function () {
    var $this = (0, _jquery2.default)(this);
    var productId = parseInt($this.attr('data-watchdog'), 10);
    var remove = $this.attr('data-watchdog-remove') === "true";

    if (remove) {
        // remove item
        wishlistService.removeItem(productId).done(function () {
            var $container = $this.parent();

            $container.find("[data-watchdog-remove='false']").removeClass('hidden');
            $container.find("[data-watchdog-remove='true']").addClass('hidden');

            _notify2.default.success(Resx.App.WatchDogRemoved);
        });
    } else {
        // add item
        wishlistService.addItem(productId).done(function (result) {
            if (result) {
                var $container = $this.parent();

                $container.find("[data-watchdog-remove='false']").addClass('hidden');
                $container.find("[data-watchdog-remove='true']").removeClass('hidden');

                _notify2.default.success(Resx.App.WatchDogAdded);
            }
        });
    }
});

(0, _jquery2.default)(document).on('click', '#btn-remove-watchdog-product-all', function () {
    _message2.default.confirm(Resx.App.WishListItemRemoveAllConfirmation, Resx.Messages.ConfirmTitle, function (isConfirmed) {
        if (isConfirmed) {
            wishlistService.removeAllItems().done(function () {
                (0, _jquery2.default)("#customerWatchdogProductGrid").DataTable().ajax.reload(null, false);
                (0, _jquery2.default)("#btn-remove-watchdog-product-all").removeClass('hidden');
                (0, _jquery2.default)("#btn-remove-watchdog-product-all").addClass('hidden');
                _notify2.default.success(Resx.App.WishListItemRemoved);
            }).fail(function (result) {
                _notify2.default.error(result.responseJSON.error.message);
            });
        }
    });
});


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/watchdog.js
// module id = 1097
// module chunks = 1